var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-5",attrs:{"elevation":"2","outlined":""}},[_c('v-card-title',[_vm._v("Counties")]),_c('v-data-table',{staticClass:"row-pointer",attrs:{"headers":_vm.headers,"items":_vm.countyData,"item-key":"code"},on:{"click:row":_vm.filterCounty}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }